export const AUTH_SESSION_CLEARED_EVENT = 'auth:session-cleared';

export const dispatchAuthSessionCleared = () => {
	if (typeof window !== 'undefined') {
		window.dispatchEvent(new Event(AUTH_SESSION_CLEARED_EVENT));
	}
};
